<template>
  <div>
    <modal @close="onCancel">
      <h3 slot="header">{{ title }}</h3>
      <div slot="body">
        <slot name="body">
        </slot>
      </div>
      <div slot="footer">
        <btn-pill btn-size="s" @click="onOk">{{ okButton }}</btn-pill>
        <btn-pill btn-size="s" @click="onCancel" btn-type="secondary">{{ cancelButton }}</btn-pill>
      </div>
    </modal>
  </div>
</template>

<script>
import BtnPill from '@/components/shared/buttons/BtnPill';
import Modal from '@/components/shared/dialogs/Modal';

export default {
  components: {
    BtnPill,
    Modal
  },
  props: {
    title: {
      type: String
    },
    message: {
      type: String
    },
    okButton: {
      type: String
    },
    cancelButton: {
      type: String
    }
  },
  created () {
    document.body.addEventListener('keyup', this.onKeyUp);
  },
  destroyed () {
    document.body.removeEventListener('keyup', this.onKeyUp);
  },
  methods: {
    onOk (event) {
      this.$emit('ok', event);
    },
    onCancel (event) {
      this.$emit('cancel', event);
    },
    onKeyUp (event) {
      switch (event.keyCode) {
        case 13:
          this.$emit('ok', event);
          break;
        case 27:
          this.$emit('cancel', event);
          break;
      }
    }
  }
};

</script>



// WEBPACK FOOTER //
// src/components/shared/dialogs/OkCancelModal.vue